import { computed, inject, Provider, signal } from '@angular/core';
import { AuthenticationService } from 'authentication-data';
import {
  provideCartItemResultComponent,
  StandardCartItemResultLayoutComponentsProviderComponent,
  StandardItemResultLayoutComponentsProviderComponent,
  StandardProductDetailLayoutCartComponentsProviderComponent,
  WireCutCartItemResultLayoutComponentsProviderComponent,
  WireCutItemResultLayoutComponentsProviderComponent,
} from 'cart-ui';
import { provideFeatureImportComponents } from 'common-util';
import { NavItemType, provideNavItems } from 'navigation-data';
import { ProductTypes } from 'products-data';
import { provideItemResultComponent, provideProductDetailsComponent, provideProductResultComponent } from 'products-ui';
import { ImportCartMenuComponent } from './import-cart-menu/import-cart-menu.component';
import { ImportStandardProductResultComponentsComponent } from './import-standard-product-result-components/import-standard-product-result-components.component';
import { ImportWireCutProductResultComponentsComponent } from './import-wire-cut-product-result-components/import-wire-cut-product-result-components.component';
import { MainMenuLocalization } from './localization/MainMenuLocalization';
import { provideCartFeatureRoutes } from './cart-feature.routes';

export function provideCartFeature(): Provider {
  return [
    provideCartFeatureRoutes(),
    provideNavItems(
      {
        type: NavItemType.RouteLink,
        id: 'app.main-menu/carts',
        label: signal(MainMenuLocalization.SavedCarts),
        icon: signal('add_shopping_cart'),
        priority: signal(51),
        command: signal([`/saved`, `carts`]),
        hidden: () => {
          const auth = inject(AuthenticationService);
          return computed(() => !auth.isAuthenticated());
        },
      },
      {
        type: NavItemType.RouteLink,
        id: 'app.main-menu/part-lists',
        label: signal(MainMenuLocalization.SavedPartLists),
        icon: signal('list_alt'),
        priority: signal(50),
        command: signal([`/saved`, `part-lists`]),
        hidden: () => {
          const auth = inject(AuthenticationService);
          return computed(() => !auth.isAuthenticated());
        },
      },
    ),

    provideFeatureImportComponents(ImportCartMenuComponent),
    provideProductResultComponent({ type: ProductTypes.Standard, component: ImportStandardProductResultComponentsComponent }),
    provideProductResultComponent({ type: ProductTypes.Wire, component: ImportWireCutProductResultComponentsComponent }),
    provideProductDetailsComponent({ type: ProductTypes.Standard, component: StandardProductDetailLayoutCartComponentsProviderComponent }),
    provideCartItemResultComponent({ type: ProductTypes.Standard, component: StandardCartItemResultLayoutComponentsProviderComponent }),
    provideCartItemResultComponent({ type: ProductTypes.Wire, component: WireCutCartItemResultLayoutComponentsProviderComponent }),
    provideItemResultComponent({ type: ProductTypes.Standard, component: StandardItemResultLayoutComponentsProviderComponent }),
    provideItemResultComponent({ type: ProductTypes.Wire, component: WireCutItemResultLayoutComponentsProviderComponent }),
  ];
}
